import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'qs';

import { LANGUAGE_LOCALSTORAGE_KEY } from '@/shared/constants/localstorage';

export const baseQuery = fetchBaseQuery({
    baseUrl: `${process.env['ALGOTECH_ENV_API_URL']}`,
    prepareHeaders: (headers, { getState }) => {
        const { accessToken } = (getState() as AppStateSchema).session;

        if (accessToken) {
            headers.set('Authorization', `Bearer ${accessToken}`);
        }

        headers.set(
            'Accept-Language',
            localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY) ??
                navigator.language,
        );

        return headers;
    },
    /**
     * redux-toolkit doesn't implement any special http library. It uses fetch under the hood.
     * For params, it uses URLSearchParams(). So the API will be similar.
     * Since URLSearchParams() doesn't support your params bracket notation.
     * That's why we added this.
     *
     * Configuration for arrays: format arrays as key=value1&key=value2
     */
    paramsSerializer: (params) =>
        qs.stringify(params, {
            arrayFormat: 'repeat',
            indices: false,
        }),
});
